import React from "react";
import { Header } from "../Header/Header";
import { SubHeader } from "../Overview/SubHeader/SubHeader";
import { Footer } from "../Overview/Footer/Footer";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import ContactUsImg from "../assets/contactUs.jpeg";
import styles from "./Contact.module.scss";

export const Contact = () => {
  return (
    <div className={styles.container}>
      <SubHeader overviewStyle={false} />
      <h1>Contactanos</h1>
      <div className={styles.content}>
        <div className={styles.leftSection}>
          <img src={ContactUsImg} alt="Contactanós" />
        </div>
        <div className={styles.rightSection}>
          <p className={styles.subtitle}>
            Si tienes alguna duda o pregunta, no dudes en contactarnos via:
          </p>
          <label className={styles.label} htmlFor="whatsapp">
            Whatsapp
          </label>
          <p className={styles.contactData} id="whatsapp">
            55 5555 5555
          </p>
          <label className={styles.label} htmlFor="email">
            Email
          </label>
          <a className={styles.linkTxt} href="mailto:" target="_blank" rel="noreferrer">
            <p className={styles.contactData} id="email">mcsd1969@gmail.com</p>
          </a>
          <label className={styles.label} htmlFor="redesSociales">
            O por cualquiera de nuestras redes sociales
          </label>
          <LinkedInIcon className={styles.icon} />
          <InstagramIcon className={styles.icon} />
          <FacebookIcon className={styles.icon} />
        </div>
      </div>
      <Footer />
    </div>
  );
};
